import { formatPhoneLabel } from '@/libraries/PhoneNumber';

export default {
    /**
     * Get the secondary identifier of a contact: its phone number, or its email.
     *
     * @param   {Object}    contact     The contact
     *
     * @return  {string}
     */
    detail (contact) {
        return contact.attributes['phone-number'] || contact.attributes.email || '';
    },

    /**
     * Get the raw name of a contact, falling back to its detail when it has no name.
     *
     * @param   {Object}    contact     The contact
     *
     * @return  {string}
     */
    name (contact) {
        return contact.attributes.name || contact.attributes['facebook-name'] || this.detail(contact);
    },

    /**
     * Get the name of a contact, ready to be displayed.
     *
     * @param   {Object}    contact     The contact
     *
     * @return  {string}
     */
    displayName (contact) {
        return formatPhoneLabel(this.name(contact));
    },

    /**
     * Get the detail of a contact ready to be displayed, empty when it would repeat the name.
     *
     * @param   {Object}    contact     The contact
     *
     * @return  {string}
     */
    displayDetail (contact) {
        const detail = this.detail(contact);

        return detail && detail !== this.name(contact) ? formatPhoneLabel(detail) : '';
    }
};
